import { styled, WhmLoadingButton, whmTheme } from "@securitize/reactjs-whm";
import { PaletteColor } from "@mui/material";

// This loading button fixes styles which were being
// affected by a reset inside the container of this MFE.
// This component might not be needed once that is corrected on the container.
export const WhmCustomLoadingButton = styled(WhmLoadingButton)(
  ({
    color,
    variant,
    disabled,
    loading,
  }: {
    color: keyof typeof whmTheme.palette;
    variant?: "text" | "outlined" | "contained" | undefined;
    disabled?: boolean;
    loading?: boolean;
  }) =>
    variant === "contained" &&
    !disabled &&
    !loading && {
      backgroundColor: `${
        (whmTheme.palette[color] as PaletteColor).main
      } !important`,
    },
);
